import React, { useEffect, useState } from 'react'
import { GetById_ObjectInstance_Api, Update_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// =================================================================
export const EditObjectInstanceComponent = ({ id, objectTypeId, setLoading, showMessage, rowUpdated, cancelEdit }) => {
    // =================================================================
    const [objectInstance, setObjectInstance] = useState();
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        loadData();
    }, [id]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_ObjectInstance_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setObjectInstance(data.messageData.data);
                form.setFieldsValue(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            values.id = id;
            values.objectTypeId = objectTypeId;
            let data = await Update_ObjectInstance_Api(values);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    return (
        <>
            {objectInstance ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {objectInstance.title}
                        </h2>
                    </div>
                    <div className='container'>
                        <Form
                            form={form}
                            name="basic"
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input placeholder='عنوان' />
                            </Form.Item>

                            <Form.Item
                                name="capacity"
                                label="ظرفیت"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="capacityFrom"
                                label="حداقل ظرفیت"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="capacityTo"
                                label="حداکثر ظرفیت"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="isMenGroup"
                                valuePropName='checked'
                                label="مجردی مردانه"
                            >
                                <Checkbox checked={objectInstance.isMenGroup}></Checkbox>
                            </Form.Item>

                            <Form.Item
                                name="isWomanGroup"
                                valuePropName='checked'
                                label="مجردی زنانه"
                            >
                                <Checkbox checked={objectInstance.isWomanGroup}></Checkbox>
                            </Form.Item>

                            <Form.Item
                                name="orderIndex"
                                label="ترتیب"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="isActive"
                                valuePropName='checked'
                                label="فعال"
                            >
                                <Checkbox checked={objectInstance.isActive}></Checkbox>
                            </Form.Item>
                        </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}
